module.exports = __webpack_public_path__ + "static/media/meniu-icon.d7daceed.svg";